import React from 'react'
import './data.scss'

const BadgeLabel = (props: {
    label: string
    color?: string
    backgroundColor?: string
}) => {
    // backgroundColor can be used to specify the color on which
    // the badge is placed, providing a transparency effect for the label text

    const { label, color, backgroundColor } = props

    let style = {
        color: backgroundColor ? backgroundColor : '',
        backgroundColor: color ? color : '',
    }

    return (
        <span style={style} className="badge-label">
            {label}
        </span>
    )
}

export default BadgeLabel
